import { path } from 'ramda';

import api from '@/api';
import { PAGES_STORE_KEY } from '@/redux/constants';
import { saveAs } from '@/utils/file-saver';

import { FEATURE_NAME, ROUTE_PATH } from './consts';

export const getItemsRoot = path([PAGES_STORE_KEY, FEATURE_NAME, 'items']);

export const getQueryRoot = path([PAGES_STORE_KEY, FEATURE_NAME, 'query']);

export const createBonusDetailsPageUrl = itemId =>
  `${ROUTE_PATH.replace(':details_id', itemId)}`;

export const createResourceIdURL = id => ROUTE_PATH.replace(':details_id', id);

export const downloadXls = (historyId, bonusName) => {
  const urlParams = new URLSearchParams(window.location.search);
  const limit = Number(urlParams.get('limit')) || 10;
  const page = Number(urlParams.get('page'));
  const offset = page * limit;

  urlParams.set('limit', limit.toString());
  urlParams.set('offset', offset.toString());
  urlParams.set('store_bonus_history_id[eq]', historyId);
  urlParams.delete('page');
  if (!urlParams.has('sort')) {
    urlParams.set('sort', 'id');
  }

  api
    .doBlobGet(
      `/store-bonus-repayment-and-cm-details-xlsx-export/${historyId}?${decodeURIComponent(
        urlParams.toString(),
      )}`,
    )
    .then(response => {
      saveAs(
        response.data,
        `[${bonusName}],Детализация бонусов на период.xlsx`,
      );
    });
};
